import React from 'react';
import { useStore } from '../store';

// Blocking error dialog — covers the whole app until the user clicks OK. Used for failures the
// user MUST see (e.g. an email that failed to send after the composer already closed).
function BlockingError() {
  const { blockingError, setBlockingError } = useStore();
  if (!blockingError) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 6000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'var(--bg-surface)', borderRadius: 14, padding: '26px 30px', width: 440, maxWidth: '92vw', boxShadow: 'var(--shadow-md)', textAlign: 'center' }}>
        <i className="ti ti-alert-triangle" style={{ fontSize: 36, color: '#E24B4A', display: 'block', marginBottom: 12 }} aria-hidden />
        <div style={{ fontSize: 14.5, fontWeight: 700, marginBottom: 10, color: 'var(--text-primary)' }}>Email failed to send</div>
        <div style={{ fontSize: 13, color: 'var(--text-secondary)', whiteSpace: 'pre-wrap', lineHeight: 1.55, marginBottom: 20, textAlign: 'left' }}>{blockingError}</div>
        <button onClick={() => setBlockingError(null)} style={{ padding: '9px 30px', borderRadius: 9, border: 'none', background: 'var(--accent)', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' }}>OK</button>
      </div>
    </div>
  );
}

export default function Toast() {
  const { toastMessage } = useStore();
  if (!toastMessage) return <BlockingError />;
  return (<>
    <BlockingError />
    <div style={{
      position: 'fixed', bottom: 24, right: 24,
      background: '#085041', color: '#9FE1CB',
      padding: '10px 18px', borderRadius: 'var(--radius-lg)',
      fontSize: 13, fontWeight: 500,
      display: 'flex', alignItems: 'center', gap: 8,
      zIndex: 2000, animation: 'slideUp 0.25s ease',
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    }}>
      <i className="ti ti-check" style={{ fontSize: 14 }} aria-hidden />
      {toastMessage}
    </div>
  </>);
}
